import { render, staticRenderFns } from "./FactoringLayout.vue?vue&type=template&id=6584ce36"
import script from "./FactoringLayout.vue?vue&type=script&lang=js"
export * from "./FactoringLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports